import { ScoreRange } from "../../types";

interface ScoreRangesProps {
  scoreRanges: [ScoreRange];
}

const ScoreRanges: React.FC<ScoreRangesProps> = ({ scoreRanges }) => {
  return (
    <div
      id="w-node-_3b32867a-de79-4d5f-10ab-d0663b4295bb-38e776aa"
      className="w-layout-layout quick-stack-4 wf-layout-layout"
    >
      {scoreRanges.map((sr: ScoreRange) => (
        <div
          id="w-node-_3b32867a-de79-4d5f-10ab-d0663b4295bc-38e776aa"
          className="w-layout-cell"
          key={sr.score_range_name}
        >
          <div className="score-div">
            <p className="paragraph-4">
              {sr.score_range_start} - {sr.score_range_end}
              <br />
              <strong>{sr.score_range_name}</strong>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScoreRanges;
